module.exports = __webpack_public_path__ + "img/image.5af02ba5.svg";